import React, { Component } from 'react';

export class POInput extends Component {
    render() {
        return (
            <div className="po-input">
                <form action="#">
                    <h1 className='title'>Scan Purchase Order</h1>
                    <input autoComplete="off" id="scanPO" autoFocus name="scanPO" value={this.props.userInput} onChange={(event) => this.props.updateInputValue(event.target.value)}></input>
                    <button onClick={this.props.lookupPO} className='submit'>Submit</button>
                </form>
            </div>
        );
    }
}